import { render, staticRenderFns } from "./ManageRequest.vue?vue&type=template&id=3afcb161"
import script from "./ManageRequest.vue?vue&type=script&lang=js"
export * from "./ManageRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports